import React from 'react';

import ModalWithTabs, {
  ModalTabs,
  ModalTabList,
  ModalTab,
  ModalTabPanels
} from '@strava/ui/ModalWithTabs';
import { t } from '../../utils/InviteFriends.utils';
import EmailTabPanel from './components/EmailTabPanel/InviteFriends.EmailTabPanel';
import FacebookTabPanel from './components/FacebookTabPanel';
import styles from './InviteFriendsModal.scss';
import { useInviteFriendsContext } from '../../state/InviteFriendsContext';
import { CLOSE_MODAL } from '../../state/InviteFriends.actions';

const InviteFriendsModal = () => {
  const { state, dispatch } = useInviteFriendsContext();

  return (
    <ModalWithTabs
      isOpen={state.isModalOpen}
      onDismiss={() => dispatch({ type: CLOSE_MODAL })}
      title={t('modal.title')}
      aria-label={t('modal.aria-label')}
    >
      <ModalTabs>
        <ModalTabList className={styles.tabList}>
          <ModalTab>{t('modal.email.title')}</ModalTab>
          <ModalTab>{t('modal.facebook.title')}</ModalTab>
        </ModalTabList>
        <ModalTabPanels className={styles.tabPanels}>
          <EmailTabPanel />
          <FacebookTabPanel />
        </ModalTabPanels>
      </ModalTabs>
    </ModalWithTabs>
  );
};

export default InviteFriendsModal;
